import React from 'react';
import './NiceLink.css';

interface NiceLinkProps {
  text: string;
  onClick?: () => void;
  href?: string;
  className?: string;
  color?: string;
}

export const NiceLink: React.FC<NiceLinkProps> = ({
  text,
  onClick,
  href,
  color = 'awasi',
  className = ''
}) => {
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      if (!href) {
        e.preventDefault();
      }
      onClick();
    }
  };

  const Element = href ? 'a' : 'button';
  const elementProps = href
    ? { href, onClick: handleClick }
    : { type: 'button' as const, onClick: handleClick };

  const componentStyle = {
      '--_color': `var(--color-${color})`,
  } as React.CSSProperties;

  return (
    <Element
      {...elementProps}
      className={`nice-link ${className}`}
      style={componentStyle}
    >
      {text}
    </Element>
  );
};